import {
  makeDataState,
  makePaginationState,
  makeListState,
  STATUSES,
} from 'app/utils/redux';

import * as t from './types';

const initialState = {
  story: makeDataState(),
  episodes: {
    storyId: null,
    ...makePaginationState(),
  },
  cheer: {
    storyId: null,
    ...makeDataState(),
  },
  cheers: {
    storyId: null,
    ...makePaginationState(),
  },
  cheerRankings: {
    storyId: null,
    ...makePaginationState(),
  },
  latestRead: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    // fetch story
    case `${t.FETCH_STORY}_PENDING`:
      return {
        ...state,
        story: {
          ...state.story,
          status: STATUSES.PENDING,
        },
      };

    case `${t.FETCH_STORY}_SUCCESS`:
      return {
        ...state,
        story: {
          status: STATUSES.SUCCESS,
          isLoaded: true,
          data: action.payload.result,
        },
        latestRead: state.latestRead || action.payload.result.latestRead,
      };

    case `${t.FETCH_STORY}_ERROR`:
      return {
        ...state,
        story: {
          ...state.story,
          status: STATUSES.ERROR,
        },
      };

    // fetch story episodes
    case `${t.FETCH_STORY_EPISODES}_PENDING`:
      return {
        ...state,
        episodes: {
          ...state.episodes,
          status: STATUSES.PENDING,
        },
      };

    case `${t.FETCH_STORY_EPISODES}_SUCCESS`:
      return {
        ...state,
        episodes: {
          storyId: action.meta.storyId,
          status: STATUSES.SUCCESS,
          isLoaded: true,
          pagination: {
            ...action.payload.result,
            items: state.episodes.pagination.items.concat(
              action.payload.result.items
            ),
          },
        },
      };

    case `${t.FETCH_STORY_EPISODES}_ERROR`:
      return {
        ...state,
        episodes: {
          ...state.episodes,
          status: STATUSES.ERROR,
        },
      };

    // follow user
    case `${t.FOLLOW_USER}_SUCCESS`: {
      if (!state.story.isLoaded) {
        return state;
      }

      return {
        ...state,
        story: {
          ...state.story,
          data: {
            ...state.story.data,
            user: {
              ...state.story.data.user,
              isFollowing: !state.story.data.user.isFollowing,
            },
          },
        },
      };
    }

    case t.UPDATE_LATEST_READ:
      return {
        ...state,
        latestRead: {
          ...action.meta.episode,
        },
      };

    case t.RESET_LATEST_READ:
      return {
        ...state,
        latestRead: null,
      };

    // reset
    case t.RESET:
      return {
        ...state,
        episodes: {
          storyId: null,
          ...makePaginationState(),
        },
      };

    case `${t.LIKE_STORY}_SUCCESS`:
    case `${t.LIKE_STORY}_ERROR`:
      return {
        ...state,
        story: {
          ...state.story,
          data: {
            ...state.story.data,
            isLiked: !state.story.data.isLiked,
          },
        },
      };

    // purchase balloon episode
    case `${t.PURCHASE_EPISODE}_SUCCESS`: {
      const { episode, story } = action.payload.result;

      return {
        ...state,
        story: {
          ...state.story,
          data: {
            ...state.story.data,
            waitfreeResetAt: story.waitfreeResetAt,
          },
        },
        episodes: {
          ...state.episodes,
          pagination: {
            ...state.episodes.pagination,
            items: state.episodes.pagination.items.map((item) => {
              if (item.id === episode.id) {
                return {
                  ...item,
                  purchaseExpiredAt: episode.purchaseExpiredAt,
                  purchaseType: episode.purchaseType,
                };
              }

              return item;
            }),
          },
        },
      };
    }

    case `${t.FETCH_STORY_CHEER}_PENDING`: {
      return {
        ...state,
        cheer: {
          ...state.cheer,
          status: STATUSES.PENDING,
        },
      };
    }

    case `${t.FETCH_STORY_CHEER}_SUCCESS`:
    case `${t.CHEER_STORY}_SUCCESS`: {
      return {
        ...state,
        cheer: {
          isLoaded: true,
          status: STATUSES.SUCCESS,
          data: action.payload.result,
        },
      };
    }

    case `${t.FETCH_STORY_CHEER}_ERROR`:
      return {
        ...state,
        cheer: {
          ...state.cheer,
          isLoaded: true,
          status: STATUSES.ERROR,
        },
      };

    // fetch following users stories
    case `${t.FETCH_STORY_CHEER_LIST}_PENDING`:
      return {
        ...state,
        cheers: {
          ...state.cheers,
          status: STATUSES.PENDING,
        },
      };
    case `${t.FETCH_STORY_CHEER_LIST}_SUCCESS`:
      return {
        ...state,
        cheers: {
          ...state.cheers,
          status: STATUSES.SUCCESS,
          isLoaded: true,
          storyId: action.meta.storyId,
          pagination: {
            ...action.payload.result,
            items: state.cheers.pagination.items.concat(
              action.payload.result.items
            ),
          },
        },
      };
    case `${t.FETCH_STORY_CHEER_LIST}_ERROR`:
      return {
        ...state,
        cheers: {
          ...state.cheers,
          status: STATUSES.ERROR,
        },
      };

    // fetch following users stories
    case `${t.FETCH_STORY_CHEER_RANKING_LIST}_PENDING`:
      return {
        ...state,
        cheerRankings: {
          ...state.cheerRankings,
          status: STATUSES.PENDING,
        },
      };
    case `${t.FETCH_STORY_CHEER_RANKING_LIST}_SUCCESS`:
      return {
        ...state,
        cheerRankings: {
          ...state.cheerRankings,
          status: STATUSES.SUCCESS,
          isLoaded: true,
          storyId: action.meta.storyId,
          pagination: {
            ...action.payload.result,
            items: state.cheerRankings.pagination.items.concat(
              action.payload.result.items
            ),
          },
        },
      };
    case `${t.FETCH_STORY_CHEER_RANKING_LIST}_ERROR`:
      return {
        ...state,
        cheerRankings: {
          ...state.cheerRankings,
          status: STATUSES.ERROR,
        },
      };

    case t.RESET_STORY_CHEER:
      return {
        ...state,
        cheer: makeDataState(),
      };

    case t.RESET_STORY_CHEER_RANKING_LIST:
      return {
        ...state,
        cheerRankings: {
          storyId: null,
          ...makePaginationState(),
        },
      };

    case t.RESET_STORY_CHEER_LIST:
      return {
        ...state,
        cheers: {
          storyId: null,
          ...makePaginationState(),
        },
      };

    case `${t.PREVIEW_BY_BALLOON}_SUCCESS`: {
      const { episode } = action.payload.result;
      return {
        ...state,
        episodes: {
          ...state.episodes,
          pagination: {
            ...state.episodes.pagination,
            items: state.episodes.pagination.items.map((item) => {
              if (item.id === episode.id) {
                return {
                  ...item,
                  purchaseType: episode.purchaseType,
                };
              }

              return item;
            }),
          },
        },
      };
    }

    default:
      return { ...state };
  }
};



// WEBPACK FOOTER //
// ./src/app/redux/front/storyDetail/reducer.js